type Area = {
	width: number
	height: number
	x: number
	y: number
}

export type OutputSize =
	| number
	| {
			width: number
			height: number
	  }

export const createImage = (url: string): Promise<HTMLImageElement> =>
	new Promise((resolve, reject) => {
		const image = new Image()
		image.onload = () => resolve(image)
		image.onerror = (error) => reject(error)
		image.src = url
	})

export const getCroppedImageBase64 = async (
	imageSrc: string,
	crop: Area,
	outputSize?: OutputSize,
): Promise<string> => {
	const image = await createImage(imageSrc)

	let targetWidth = crop.width
	let targetHeight = crop.height

	if (typeof outputSize === 'number') {
		targetWidth = outputSize
		targetHeight = outputSize
	} else if (outputSize) {
		targetWidth = outputSize.width
		targetHeight = outputSize.height
	}

	const canvas = document.createElement('canvas')
	canvas.width = targetWidth
	canvas.height = targetHeight

	const context = canvas.getContext('2d')

	if (!context) {
		throw new Error('Failed to get 2D context')
	}

	context.drawImage(
		image,
		crop.x,
		crop.y,
		crop.width,
		crop.height,
		0,
		0,
		targetWidth,
		targetHeight,
	)

	return canvas.toDataURL('image/png')
}
